var ChannelAvailability;
(function(ChannelAvailability) {
    ChannelAvailability["ONLINE"] = "ONLINE";
    ChannelAvailability["IN_STORE_ONLY"] = "IN_STORE_ONLY";
})(ChannelAvailability || (ChannelAvailability = {}));

export { ChannelAvailability };
//# sourceMappingURL=product.js.map
